import { isSameDay, parseISO } from 'date-fns';

const useIsCompletedToday = (date: string) => {
  const currentDate = new Date();

  return isSameDay(parseISO(date), currentDate);
};

export default useIsCompletedToday;
